import {connect} from 'react-redux';
import Loading from "../ui/Loading";

const mapStateToProps = state => {
    return {
        isLoading: state.isProcessing
    }
};

export default connect(mapStateToProps)(Loading)
